export const DOUBLE_VERIFICATION_EMAIL = 'double_verification_email';
